import React, { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  ArchiveChat,
  DeleteChat,
  PinChat,
  UnArchiveChat,
  UnPinChat,
} from "../../../redux/actions/chatActions";
import {
  ArchiveChatOutlineIcon,
  ChatMoreOptionArrow,
  DeleteChatOutlineIcon,
  PinChatOutlineIcon,
} from "../../../assets/svgs/SvgsImg";
import { MdOutlineCheck } from "react-icons/md";
import useOutsideClick from "../../../utils/hooks/useOutsideClickHook";
import { Overlay } from "react-bootstrap";
import DeletePopUp from "../../Dailogs/DeletePopUp";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";

const ChatOptions = ({ room }) => {
  const dispatch = useDispatch();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const refOptions = useRef();
  const refOverlay = useRef();

  const [fetchTransChatList, setFetchTransChatList] = useState({});
  const t = (key) => fetchTransChatList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Chat").then((data) => setFetchTransChatList(data));
  }, []);

  const toggleMenuOpen = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setMenuOpen((p) => !p);
  };

  const onMenuClick = (event, type) => {
    event.stopPropagation();
    event.preventDefault();
    switch (type) {
      case "PIN":
        room.isPinned
          ? dispatch(UnPinChat({ groupid: room.groupid }))
          : dispatch(PinChat({ groupid: room.groupid }));
        setMenuOpen(false);
        break;
      case "ARCHIVE":
        room.isArchived
          ? dispatch(UnArchiveChat({ groupid: room.groupid }))
          : dispatch(ArchiveChat({ groupid: room.groupid }));
        setMenuOpen(false);
        break;
      case "DELETE":
        setDeletePopup(true);
        setMenuOpen(false);
        break;
    }
  };

  const onDeleteConfirm = (event) => {
    event.stopPropagation();
    event.preventDefault();
    dispatch(DeleteChat(room));
    setDeletePopup(false);
  };

  const onDeleteRefuse = (event) => {
    event?.stopPropagation();
    event?.preventDefault();
    setDeletePopup(false);
  };

  useOutsideClick(() => {
    setMenuOpen(false);
  }, [refOptions, refOverlay]);
  return (
    <>
      <div
        ref={refOptions}
        className={`chat-options ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMenuOpen}
      >
        <ChatMoreOptionArrow />
      </div>
      <DeletePopUp
        show={deletePopup}
        handleDelete={onDeleteConfirm}
        onHide={onDeleteRefuse}
        title1={"You are deleteing this conversation."}
        title3={"Do you want to proceed?"}
        yes={"Yes"}
        no={"No"}
      />
      <Overlay
        target={refOptions.current}
        show={isMenuOpen}
        placement="left-start"
      >
        {(props) => (
          <div {...props} style={{ ...props.style }}>
            <div
              className="chat-menu-options-container"
              ref={refOverlay}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              {!Boolean(room.isArchived) && (
                <div
                  className="chat-menu-option-item"
                  onClick={(e) => onMenuClick(e, "PIN")}
                >
                  <div className="d-flex align-items-center gap-2">
                    <PinChatOutlineIcon />
                    {/* Pin on top */}
                    {room.isPinned ? "Unpin from top" : t("Pin on top")}
                  </div>
                  {room.isPinned && (
                    <MdOutlineCheck size={16} color="#333333" />
                  )}
                </div>
              )}
              <div
                className="chat-menu-option-item"
                onClick={(e) => onMenuClick(e, "ARCHIVE")}
              >
                <div className="d-flex align-items-center gap-2">
                  <ArchiveChatOutlineIcon />
                  {/* {room.isArchived ? "Unarchive" : "Archive conversation"} */}
                  {room.isArchived
                    ? t("Unarchive ")
                    : t("Archive Conversations")}
                </div>
              </div>
              <div
                className="chat-menu-option-item"
                onClick={(e) => onMenuClick(e, "DELETE")}
              >
                <div className="d-flex align-items-center gap-2">
                  <DeleteChatOutlineIcon />
                  {/* Delete conversation */}
                  {t("Delete Conversations")}
                </div>
              </div>
            </div>
          </div>
        )}
      </Overlay>
    </>
  );
};

export default ChatOptions;
